import React from 'react';
import styled from 'styled-components/macro';

interface IProps {
  label: string;
}

const StyledTitle = styled.div`
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography[1]};
  border-radius: ${({ theme }) => theme.radius.full};
  background: ${({ theme }) => theme.colors.black};
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[6]}`};
  color: ${({ theme }) => theme.colors.white};
  z-index: 10;
`;

const Title: React.FC<IProps> = ({ label }) => {
  return (
    <StyledTitle>
      {label}
    </StyledTitle>
  );
};

export { Title };
